import { render, staticRenderFns } from "./RegisterConfirmationView.vue?vue&type=template&id=6d4034ed&"
import script from "./RegisterConfirmationView.vue?vue&type=script&lang=ts&"
export * from "./RegisterConfirmationView.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterConfirmationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports